import React from "react";
const SpamhausEDROPAdapterFieldSet = () => /* @__PURE__ */ React.createElement("fieldset", null);
export default SpamhausEDROPAdapterFieldSet;
